import apiClient from "@/api/apiClient";
import type { PaginatedMaintenanceItemToPart } from "@/api/resources/maintenanceItemsToParts/types";
import type { ArgsAddPartToMaintenanceItem, MaintenanceItemToPart } from "@/supabase.types";
import {
  spawnCreateApiFunction,
  spawnDeleteApiFunction,
  spawnUpdateApiFunction,
  type ApiResourceConfig,
} from "@/utils/api";

const table = "maintenance_items_to_parts";
const query = `
  *,
  maintenance_item:maintenance_items(id, workspace_id, deployment_id),
  part:parts(
    *,
    part_model:part_models(
      *,
      part_manufacturer:part_manufacturers(*),
      part_category:part_categories(*),
      constraints:part_model_constraints(*)
    ),
    part_locations:part_to_part_locations!part_to_part_locations_part_id_fkey(
      *,
      part_location:part_locations(
        *,
        part_location_template:part_location_templates(*)
      )
    )
  ),
  part_category:part_categories(*),
  part_model:part_models(
    *,
    part_manufacturer:part_manufacturers(*),
    part_category:part_categories(*)
  )
`;

export const apiConfigMaintenanceItemsToParts: ApiResourceConfig<typeof table, typeof query> = {
  table,
  query,
  searchables: [],
  sortables: [],
};

export const createMaintenanceItemToPart = spawnCreateApiFunction({ table, query });
export const updateMaintenanceItemToPart = spawnUpdateApiFunction({ table, query });
export const deleteMaintenanceItemToPart = spawnDeleteApiFunction({ table });

export const getMaintenanceItemsToPartsByMaintenanceItem = async (
  maintenance_item_id: string,
): Promise<PaginatedMaintenanceItemToPart[]> => {
  const { data, error } = await apiClient.from(table).select(query).eq("maintenance_item_id", maintenance_item_id);
  if (error) throw error;
  return data;
};

export const addPartToMaintenanceItem = async (props: ArgsAddPartToMaintenanceItem): Promise<MaintenanceItemToPart> => {
  const { data, error } = await apiClient.rpc("add_part_to_maintenance_item", props);
  if (error) throw error;
  return data;
};
